export const PENDING_REPORTS_NEW = 'new-pending-report';
export const MAIN_ALERT_MESSAGE = 'main-alert-msg';
export const SESSION_EXPIRE = 'session-expire';
export const SW_UPDATE = 'sw-update';
export const UPDATE_REPORT_LIST = 'update-report-list';
export const MAIN_INIT = 'main-init';
